import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BigNeonLogo } from './Logo';
import { useQuoteModal } from '../../contexts/QuoteModalContext';

const HERO_VIDEO_URL =
  'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/jocr8ro1_C-LOS%20BDAY%20-%20PUSHA%20TEEZ%20.MP4';

export default function Hero() {
  const { openModal } = useQuoteModal();
  return (
    <section className="relative min-h-screen w-full bg-black overflow-hidden flex flex-col items-center justify-center pt-28 pb-16">
      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={HERO_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />

      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/55" />
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, rgba(0,0,0,0.2), rgba(0,0,0,0.65) 75%)',
        }}
      />

      {/* Subtle accent glow on top */}
      <div
        className="pointer-events-none absolute inset-0 opacity-50 mix-blend-screen"
        style={{
          background:
            'radial-gradient(circle at 50% 35%, rgba(0,184,255,0.18), transparent 55%), radial-gradient(circle at 80% 20%, rgba(57,255,20,0.10), transparent 50%)',
        }}
      />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 text-center">
        <BigNeonLogo compact />
        <h1 className="font-display text-[#f4efe6] uppercase leading-[0.92] tracking-tight text-[64px] sm:text-[88px] md:text-[128px] lg:text-[164px] mt-2 drop-shadow-[0_4px_24px_rgba(0,0,0,0.8)]" data-testid="hero-title">
          Merch{' '}
          <span className="text-[#00b8ff] italic font-script normal-case drop-shadow-[0_0_20px_rgba(0,184,255,0.45)]">
            reimagined
          </span>
        </h1>

        <p className="text-[#e9e2d4] text-base md:text-lg max-w-2xl mx-auto mt-8 leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.85)]" data-testid="hero-subline">
          Screen printing, embroidery, DTG &amp; DTF, cut and sew and more — produced for artists,
          brands and clothing labels, with live event printing when you need it on site.{' '}
          <span className="text-[#00b8ff] font-medium">Pusha Teez</span> is where
          culture meets custom merch.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <button
            type="button"
            onClick={openModal}
            className="group inline-flex items-center justify-center gap-2 bg-[#00b8ff] text-black rounded-full px-8 py-4 font-semibold text-[15px] hover:bg-[#f4efe6] transition-colors duration-200"
            data-testid="hero-quote-btn"
          >
            Get a Production Quote
            <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
          </button>
          <Link
            to="/work"
            className="inline-flex items-center justify-center gap-2 border border-white/30 text-[#f4efe6] rounded-full px-8 py-4 font-semibold text-[15px] bg-black/30 backdrop-blur-sm hover:bg-white/10 transition-colors duration-200"
            data-testid="hero-work-link"
          >
            See Our Work
          </Link>
        </div>
      </div>
    </section>
  );
}
